const modals = {
  hu: {
    // GenerateModal
    generateTitle: "Újragenerálás",
    generateWhat: "Mit generáljunk?",
    generateFullWork: "Teljes munka",
    generateSpecificColors: "Specifikus színek",
    generateSpecificTables: "Specifikus táblák",
    generateMode: "Generálási mód",
    generateModeFull: "Teljes újragenerálás",
    generateModeLines: "Csak vonalak újragenerálása",
    generateBtn: "Generálás",

    // ExportModal
    exportTitle: "Exportálás",
    exportFullWork: "Teljes munka exportálása",
    exportColors: "Színek exportálása",
    exportSpecificTables: "Specifikus táblák exportálása",
    exportBtn: "Exportálás",

    // NewWorkModal
    newWorkTitle: "Új munka létrehozása",
    newWorkName: "Név",
    newWorkNamePlaceholder: "Írd be a munka nevét",
    newWorkNameError: "Írd be munka nevét",
    newWorkServerError: "Szerver hiba, próbál újra később.",
    newWorkSubmit: "Új munka létrehozása",

    // NewClientModal
    newClientTitle: "Új kliens létrehozása",
    newClientName: "Név",
    newClientNamePlaceholder: "Kliens neve",
    newClientTel: "Telefonszám",
    newClientTelPlaceholder: "Kliens telefonszáma",
    newClientAddress: "Cím",
    newClientAddressPlaceholder: "Kliens címe",
    newClientFieldsError: "Kérlek töltsd ki az összes mezőt.",
    newClientServerError: "Belső szerver hiba, kérlek próbáld újra.",
    newClientSubmit: "Kliens hozzáadása",

    // ClientUpdateModal
    clientUpdateName: "Név",
    clientUpdateNamePlaceholder: "Add meg a nevét",
    clientUpdateTel: "Telefon",
    clientUpdateTelPlaceholder: "Add meg a telefonszámot",
    clientUpdateAddress: "Cím",
    clientUpdateAddressPlaceholder: "Add meg a címet",
    clientUpdateSubmit: "Kliens módosítása",
    clientUpdateLoadError: "Hiba: nem sikerült lekérni a kliens adatait",
    clientUpdateNoChange: "Hiba: Nem történt módosítás",

    // AddColorModal
    addColorTitle: "Szín hozzáadása",
    editColorTitle: "Szín szerkesztése",
    colorNameLabel: "Szín neve",
    colorNamePlaceholder: "Írd be a szín nevét",
    colorTypeLabel: "Anyag",
    colorGroupLabel: "Csoport",
    colorGroupPlaceholder: "Írd be a csoport nevét",
    colorDimensionLabel: "Méretek",
    colorSplitSwitch: "Darabolás engedélyezése",
    colorSplitDefault: "Alapértelmezett",
    colorSplitPlaceholder: 'Pl. "[2780,1025,18]"',
    colorRotableLabel: "Forgathatóság",
    colorRotableTrue: "Forgatható",
    colorRotableFalse: "Nem forgatható",
    colorActiveLabel: "Elérhetőség",
    colorActiveTrue: "Elérhető",
    colorActiveFalse: "Nem érhető el",
    colorPriceLabel: "Ár",
    colorImageLabel: "Kép",
    colorImageNote:
      "Jelenleg betöltött kép (cserélheted ha újat választasz ki)",
    colorNoImage: "Nincs kép kiválasztva",
    colorNoImageAlert: "Kérlek tölts fel képet.",
    colorMillingTitle: "Marás hozzárendelése",
    colorMillingShowAll: "Összes mutatása",
    colorMillingShowCompatible: "Csak kompatibilis",
    colorMillingSearch: "Keresés...",
    colorMillingNone: "Nincs elérhető marás",
    colorMillingIncompatible: "nem kompatibilis",
    colorSaveBtn: "Módosítások mentése",
    colorAddBtn: "Szín hozzáadása",
    colorPreviewTitle: "Előnézet",
    addClientTitle: "Kliens hozzáadása",
    editClientTitle: "Kliens szerkesztése",
    deleteConfirmTitle: "Törlés megerősítése",
    deleteConfirmBody: "Biztosan törölni szeretnéd ezt a klienst?",
    // ColorSelector
    colorSelectorTitle: "Szín kiválasztás",
    colorSelectorSearch: "Keresés...",
    colorSelectorSelected: "Kiválasztott szín:",
    colorSelectorSave: "Szín mentése",
    colorSelectorClose: "Bezárás",
    colorSelectorWoodPattern: "Fa minta",
    colorSelectorUniColors: "Uni színek"
  },
  ro: {
    generateTitle: "Regenerare",
    generateWhat: "Ce generăm?",
    generateFullWork: "Lucrare completă",
    generateSpecificColors: "Culori specifice",
    generateSpecificTables: "Plăci specifice",
    generateMode: "Mod de generare",
    generateModeFull: "Regenerare completă",
    generateModeLines: "Doar regenerare linii",
    generateBtn: "Generează",

    exportTitle: "Exportare",
    exportFullWork: "Exportare lucrare completă",
    exportColors: "Exportare culori",
    exportSpecificTables: "Exportare plăci specifice",
    exportBtn: "Exportează",

    newWorkTitle: "Creare lucrare nouă",
    newWorkName: "Nume",
    newWorkNamePlaceholder: "Introduceți numele lucrării",
    newWorkNameError: "Introduceți numele lucrării",
    newWorkServerError: "Eroare server, încercați din nou.",
    newWorkSubmit: "Creare lucrare nouă",

    newClientTitle: "Creare client nou",
    newClientName: "Nume",
    newClientNamePlaceholder: "Numele clientului",
    newClientTel: "Telefon",
    newClientTelPlaceholder: "Telefonul clientului",
    newClientAddress: "Adresă",
    newClientAddressPlaceholder: "Adresa clientului",
    newClientFieldsError: "Vă rugăm completați toate câmpurile.",
    newClientServerError: "Eroare internă server, încercați din nou.",
    newClientSubmit: "Adăugare client",

    clientUpdateName: "Nume",
    clientUpdateNamePlaceholder: "Introduceți numele",
    clientUpdateTel: "Telefon",
    clientUpdateTelPlaceholder: "Introduceți telefonul",
    clientUpdateAddress: "Adresă",
    clientUpdateAddressPlaceholder: "Introduceți adresa",
    clientUpdateSubmit: "Modificare client",
    clientUpdateLoadError: "Eroare: nu s-au putut încărca datele clientului",
    clientUpdateNoChange: "Eroare: Nu s-a efectuat nicio modificare",

    addColorTitle: "Adăugare culoare",
    editColorTitle: "Editare culoare",
    colorNameLabel: "Numele culorii",
    colorNamePlaceholder: "Introduceți numele culorii",
    colorTypeLabel: "Material",
    colorGroupLabel: "Grup",
    colorGroupPlaceholder: "Introduceți numele grupului",
    colorDimensionLabel: "Dimensiuni",
    colorSplitSwitch: "Activare divizare",
    colorSplitDefault: "Implicit",
    colorSplitPlaceholder: 'Ex. "[2780,1025,18]"',
    colorRotableLabel: "Rotabilitate",
    colorRotableTrue: "Rotabil",
    colorRotableFalse: "Nerotabil",
    colorActiveLabel: "Disponibilitate",
    colorActiveTrue: "Disponibil",
    colorActiveFalse: "Indisponibil",
    colorPriceLabel: "Preț",
    colorImageLabel: "Imagine",
    colorImageNote: "Imagine încărcată curent (o puteți înlocui)",
    colorNoImage: "Nicio imagine selectată",
    colorNoImageAlert: "Vă rugăm încărcați o imagine.",
    colorMillingTitle: "Atribuire frezare",
    colorMillingShowAll: "Afișează toate",
    colorMillingShowCompatible: "Doar compatibile",
    colorMillingSearch: "Căutare...",
    colorMillingNone: "Nu există frezare disponibilă",
    colorMillingIncompatible: "incompatibil",
    colorSaveBtn: "Salvare modificări",
    colorAddBtn: "Adăugare culoare",
    colorPreviewTitle: "Previzualizare",
    addClientTitle: "Adăugare client",
    editClientTitle: "Editare client",
    deleteConfirmTitle: "Confirmare ștergere",
    deleteConfirmBody: "Sigur dorești să ștergi acest client?",
    colorSelectorTitle: "Selectare culoare",
    colorSelectorSearch: "Căutare...",
    colorSelectorSelected: "Culoare selectată:",
    colorSelectorSave: "Salvare culoare",
    colorSelectorClose: "Închidere",
    colorSelectorWoodPattern: "Model lemn",
    colorSelectorUniColors: "Culori uni"
  },
  en: {
    generateTitle: "Regenerate",
    generateWhat: "What to generate?",
    generateFullWork: "Full work",
    generateSpecificColors: "Specific colors",
    generateSpecificTables: "Specific tables",
    generateMode: "Generation mode",
    generateModeFull: "Full regeneration",
    generateModeLines: "Lines only",
    generateBtn: "Generate",

    exportTitle: "Export",
    exportFullWork: "Export full work",
    exportColors: "Export colors",
    exportSpecificTables: "Export specific tables",
    exportBtn: "Export",

    newWorkTitle: "Create new work",
    newWorkName: "Name",
    newWorkNamePlaceholder: "Enter work name",
    newWorkNameError: "Enter work name",
    newWorkServerError: "Server error, please try again.",
    newWorkSubmit: "Create new work",

    newClientTitle: "Create new client",
    newClientName: "Name",
    newClientNamePlaceholder: "Client name",
    newClientTel: "Phone",
    newClientTelPlaceholder: "Client phone",
    newClientAddress: "Address",
    newClientAddressPlaceholder: "Client address",
    newClientFieldsError: "Please fill in all fields.",
    newClientServerError: "Internal server error, please try again.",
    newClientSubmit: "Add client",

    clientUpdateName: "Name",
    clientUpdateNamePlaceholder: "Enter name",
    clientUpdateTel: "Phone",
    clientUpdateTelPlaceholder: "Enter phone",
    clientUpdateAddress: "Address",
    clientUpdateAddressPlaceholder: "Enter address",
    clientUpdateSubmit: "Update client",
    clientUpdateLoadError: "Error: could not load client data",
    clientUpdateNoChange: "Error: No changes were made",

    addColorTitle: "Add color",
    editColorTitle: "Edit color",
    colorNameLabel: "Color name",
    colorNamePlaceholder: "Enter color name",
    colorTypeLabel: "Material",
    colorGroupLabel: "Group",
    colorGroupPlaceholder: "Enter group name",
    colorDimensionLabel: "Dimensions",
    colorSplitSwitch: "Enable splitting",
    colorSplitDefault: "Default",
    colorSplitPlaceholder: 'e.g. "[2780,1025,18]"',
    colorRotableLabel: "Rotatability",
    colorRotableTrue: "Rotatable",
    colorRotableFalse: "Not rotatable",
    colorActiveLabel: "Availability",
    colorActiveTrue: "Available",
    colorActiveFalse: "Not available",
    colorPriceLabel: "Price",
    colorImageLabel: "Image",
    colorImageNote: "Currently loaded image (replace by selecting a new one)",
    colorNoImage: "No image selected",
    colorNoImageAlert: "Please upload an image.",
    colorMillingTitle: "Assign milling",
    colorMillingShowAll: "Show all",
    colorMillingShowCompatible: "Compatible only",
    colorMillingSearch: "Search...",
    colorMillingNone: "No milling available",
    colorMillingIncompatible: "incompatible",
    colorSaveBtn: "Save changes",
    colorAddBtn: "Add color",
    colorPreviewTitle: "Preview",
    addClientTitle: "Add client",
    editClientTitle: "Edit client",
    deleteConfirmTitle: "Confirm deletion",
    deleteConfirmBody: "Are you sure you want to delete this client?",
    colorSelectorTitle: "Color selection",
    colorSelectorSearch: "Search...",
    colorSelectorSelected: "Selected color:",
    colorSelectorSave: "Save color",
    colorSelectorClose: "Close",
    colorSelectorWoodPattern: "Wood pattern",
    colorSelectorUniColors: "Uni colors"
  }
};

export default modals;
